"use strict";
var React = require("react");
var { Modal, Button, ButtonToolbar, closeButton } = require("react-bootstrap");
var InventoryItemForm = require("./InventoryItemForm");
var InventoryStore = require("../../stores/InventoryStore");
var CompanyStore = require("../../stores/CompanyStore");
var AuthStore = require("../../stores/AuthenticationStore");
var _ = require("underscore");

var EditInventoryItemFormModal = React.createClass({
  getInitialState: function() {
    const userData = AuthStore.getState();
    let allowEdit = false;
    if(this.props.equipment) {
      //tékka á hvort sé hlutverk á búnaðinum og hvort notandinn sé með access (yfir deildaraðgangi)
      //tékka á hvort notandinn hafi skrifaðgang að deildninni sem búnaðurinn er í
      if(this.props.equipment.required_role){
        //if the equipment has role
        for (let i = 0; i < userData.roles.length; i++) {
          if (userData.roles[i] === this.props.equipment.required_role) {
            allowEdit = true;
          }
        }
      } else {
        // check if user has access to department
        var department_access = userData.access[this.props.equipment.department];
        //check if the department access is listed under user access and if he has
        //permission to edit we allow him to edit
        if(department_access && department_access >= 3) {
          allowEdit = true;
        }
      }
    } else {
      allowEdit = false;
    }
    return {
      allowEdit: allowEdit
    }
  },
  componentDidMount() {
    AuthStore.listen(this.onChange);
  },
  componentWillUnmount() {
    AuthStore.unlisten(this.onChange);
  },
  onChange: function() {
    this.setState(this.getInitialState());
  },
  onSubmit(event) {
    event.preventDefault();
    this.refs.inventoryItemForm.onSubmit();
  },
  render: function() {
    return (
      <Modal className="drawer" id="editInventoryModal" {...this.props} bsStyle="primary" animation={true}>
        <Modal.Header closeButton>
          <Modal.Title>Breyta búnaði</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InventoryItemForm equipment={this.props.equipment} onClose={this.props.onHide} ref="inventoryItemForm" mode="edit" />
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar>
            <Button className="btn-success" onClick={this.onSubmit} type='submit' disabled={!this.state.allowEdit}>Vista</Button>
            <Button onClick={this.props.onHide}>Loka</Button>
          </ButtonToolbar>
          {(!this.state.allowEdit) &&
          <div className="modal-footer-notes text-center"><small><strong>ATH:</strong> Notandinn þinn hefur ekki réttindi til að breyta þessum búnaði.<br/> Vinsamlegast hafðu samband við stjórnanda ef þú telur þig þurfa að breyta þessum búnaði.</small></div>
          }
        </Modal.Footer>
      </Modal>
    );
  }
});

module.exports = EditInventoryItemFormModal;



// WEBPACK FOOTER //
// ./app/scripts/ui/Inventory/EditInventoryItemFormModal.js